import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { N30A } from '@atlaskit/theme/colors';
import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import { headingSizes } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';
var gridSize = gridSizeFn();
var itemHeadingTopMargin = gridSize * 2.5;
var itemHeadingBottomMargin = gridSize * 0.75; // Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.

var itemHeadingContentHeight = headingSizes.h100.lineHeight;
var skeletonHeadingHeight = gridSize;
var skeletonHeadingMarginOffset = 3;
var skeletonHeadingTopMargin = itemHeadingTopMargin + (itemHeadingContentHeight - skeletonHeadingHeight) - skeletonHeadingMarginOffset; // We want to move the entire body up by 3px without affecting the height of the skeleton container.

var skeletonHeadingBottomMargin = itemHeadingBottomMargin + skeletonHeadingMarginOffset;
var sectionPaddingTopBottom = gridSize * 0.75;
var VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
export var sectionCSS = function sectionCSS(isScrollable, hasSeparator) {
  return _objectSpread(_objectSpread(_objectSpread({
    '&:before, &:after': {
      content: '" "',
      display: 'block',
      height: sectionPaddingTopBottom
    },
    '& [data-ds--menu--heading-item]': {
      '&:first-of-type': {
        marginTop: itemHeadingTopMargin - sectionPaddingTopBottom
      },
      marginTop: itemHeadingTopMargin,
      marginBottom: itemHeadingBottomMargin
    },
    '& [data-ds--menu--skeleton-heading-item]': {
      '&:first-of-type': {
        marginTop: skeletonHeadingTopMargin - sectionPaddingTopBottom
      },
      marginTop: skeletonHeadingTopMargin,
      marginBottom: skeletonHeadingBottomMargin
    }
  }, isScrollable ? {
    flexShrink: 1,
    overflow: 'auto'
  } : {
    flexShrink: 0
  }), hasSeparator ? {
    borderTop: "2px solid var(".concat(VAR_SEPARATOR_COLOR, ", ").concat(token('color.border.neutral', N30A), ")")
  } : {
    // this is to ensure that adjacent sections without separators don't get additional margins.
    '[data-section] + &': {
      marginTop: -6
    }
  }), {}, {
    '&:focus': {
      // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
      // We have made a deliberate choice to leave this behaviour as is.
      // This makes the outline go inside by 1px so it can actually be displayed
      // else it gets cut off from the overflow: scroll from the parent menu group.
      outlineOffset: -1
    }
  });
};